// Subdominio de un boliche que no existe (slug desconocido/mal tipeado). Se usa tanto en
// la home pública como en el /admin, para que ambos sean coherentes: nunca mostramos un
// boliche por defecto ni un login de un boliche inexistente.
export default function VenueNotFound() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px 24px' }}>
      <img src="/landing/tukipro-logo.svg" alt="TUKIPRO" style={{ height: 30, marginBottom: 32 }} />
      <div className="lb-display" style={{ fontSize: 30, color: 'var(--red-400)' }}>Boliche no encontrado</div>
      <p style={{ color: 'var(--ink-700)', marginTop: 14, maxWidth: 420, lineHeight: 1.55 }}>
        No existe un boliche en esta dirección. Revisá el link o el nombre del subdominio.
      </p>
      <a href="https://tukipro.com" style={{ marginTop: 24, color: 'var(--ink-600)', fontSize: 13, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Ir a tukipro.com →</a>
    </div>
  );
}
